import { render } from "./InclusionResources.vue?vue&type=template&id=f8f5796e&scoped=true&ts=true"
import script from "./InclusionResources.vue?vue&type=script&lang=ts"
export * from "./InclusionResources.vue?vue&type=script&lang=ts"

import "./InclusionResources.vue?vue&type=style&index=0&id=f8f5796e&scoped=true&lang=css"
import "./InclusionResources.vue?vue&type=style&index=1&id=f8f5796e&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8f5796e"]])

export default __exports__